const ChartCard = ({ title, children }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border p-4 border-gray-100 hover:shadow-md transition">
      <h3 className="text-lg font-semibold text-gray-800 mb-3 text-center">
        {title}
      </h3>
      <div className="h-[350px]">{children}</div>
    </div>
  );
};

export default ChartCard;